/* istanbul ignore file */
import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ModalWindowComponent } from '../modal-window/modal-window.component';
import { ADPComponentsModule } from 'digital-core';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-session-timeout-modal-window',
    templateUrl: './session-timeout-modal-window.component.html',
    imports: [ModalWindowComponent, ADPComponentsModule, MatButton]
})
export class SessionTimeoutModalWindowComponent {

  constructor(
    public dialogRef: MatDialogRef<SessionTimeoutModalWindowComponent>,
    @Inject(MAT_DIALOG_DATA) public modalData: any,
  ) {
  }

  onClose(value: string) {
    this.dialogRef.close(value);
  }
}
